import { useNavigate, useLocation, Link } from 'react-router-dom'
import { FaInstagram, FaFacebook } from 'react-icons/fa'
import { useLanguage } from '../i18n'

const HEADER_HEIGHT = 80

const Footer = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useLanguage()

  // Navigation items with translations
  const navItems = [
    { label: t('nav.services'), type: 'section', id: 'services' },
    { label: t('nav.faq'), type: 'section', id: 'faq' },
    { label: t('nav.coach'), type: 'section', id: 'coach' },
    { label: t('nav.process'), type: 'section', id: 'process' },
    { label: t('nav.gallery'), type: 'section', id: 'gallery' },
    { label: t('nav.camps'), type: 'route', path: '/camps' },
    { label: t('nav.contact'), type: 'route', path: '/contact' }
  ]

  const handleNavClick = (e, item) => {
    e.preventDefault()

    if (item.type === 'section') {
      if (location.pathname === '/') {
        const element = document.getElementById(item.id)
        if (element) {
          const elementPosition = element.getBoundingClientRect().top
          const offsetPosition = elementPosition + window.pageYOffset - HEADER_HEIGHT

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
        }
      } else {
        navigate(`/#${item.id}`)
      }
    } else if (item.type === 'route') {
      navigate(item.path)
    }
  }

  return (
    <footer className="bg-gray-900 text-white py-10 md:py-12 border-t border-orange-500/20">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center md:text-left">
            <div className="flex justify-center md:justify-start">
              <img
                src="/logo.png"
                alt="Wind Tunnel Coaching"
                className="w-[7rem] md:w-[8rem] h-auto"
                width="64"
                height="64"
                loading="lazy"
              />
            </div>
            <p className="text-gray-400">{t('footer.tagline')}</p>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-bold mb-4 text-orange-500">{t('footer.contact')}</h4>
            <p className="text-gray-400">Tunnelcoaching1o1@gmail.com</p>
            <p className="text-gray-400">+34 643 09 13 50</p>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-bold mb-4 text-orange-500">{t('footer.quickLinks')}</h4>
            <div className="flex flex-col items-center md:items-start">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.type === 'section' ? `#${item.id}` : item.path}
                  onClick={(e) => handleNavClick(e, item)}
                  className="text-gray-400 mb-2 hover:text-orange-500 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-bold mb-4 text-orange-500">{t('footer.followUs')}</h4>
            <div className="flex justify-center md:justify-start space-x-4">
              <a
                href="https://www.instagram.com/alexmatei.fly?igsh=dTZxZXEwZ2Fpbzhp"
                className="text-gray-400 hover:text-orange-500 transition-colors"
                aria-label="Follow us on Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={24} />
              </a>
              <a
                href="https://www.facebook.com/share/1CPQVa2pB9/"
                className="text-gray-400 hover:text-orange-500 transition-colors"
                aria-label="Follow us on Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-800 text-center text-gray-500 text-sm">
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-orange-400 transition-colors">
              {t('footer.privacyPolicy')}
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/cookie-policy" className="text-gray-400 hover:text-orange-400 transition-colors">
              {t('footer.cookiePolicy')}
            </Link>
          </div>
        
        </div>
      </div>
    </footer>
  )
}

export default Footer
